import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';
import { Asset } from '@/types';

type TextDetailsProps = {
  asset: Asset;
};
export const TextDetails = ({ asset }: TextDetailsProps) => {
  const [t] = useTranslation('common');

  return (
    <div className='flex size-full flex-col px-6'>
      <div className='flex flex-col gap-y-5'>
        <div className='flex flex-col gap-y-2.5'>
          <Label text={t('title')} type={LABEL_TYPE.PARAGRAPH1_BOLD} />
          <Label
            text={asset.assetName}
            type={LABEL_TYPE.PARAGRAPH1}
            className='!text-primary-black'
          />
        </div>
        <div className='flex w-full flex-col gap-y-2.5'>
          <Label text={t('content')} type={LABEL_TYPE.PARAGRAPH1_BOLD} />
          <Label
            text={asset.additionalData}
            type={LABEL_TYPE.PARAGRAPH1}
            className='whitespace-pre-line break-words !text-primary-black'
          />
        </div>
      </div>
    </div>
  );
};
